var _defs, _rect, _rect2, _circle, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubdivsLogoDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "35%",
    cy: "35%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6FC4E3",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4A93AC",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sphere",
    cx: "35%",
    cy: "32%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8FDCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#38B0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1C6E92"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 320,
    height: 320,
    rx: 20,
    fill: "#EAF3F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 65,
    width: 270,
    height: 270,
    rx: 70,
    fill: "url(#glow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 110,
    fill: "url(#sphere)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 155,
    rx: 34,
    ry: 24,
    fill: "#FFFFFF",
    opacity: 0.9,
    transform: "rotate(-25 160 155)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubdivsLogoDark);
export default __webpack_public_path__ + "static/media/subdivs-logo-dark.025204a9cc1ca7b267210169848a4da6.svg";
export { ForwardRef as ReactComponent };